<template>
    <div class="background">
        <div class="container">
            <div class="column" v-if="benefitMap.small && benefitMap.small.length > 0">
                <van-row gutter="10">
                    <van-col v-for="item in benefitMap.small" span="6" style="margin-bottom: 1rem;">
                        <a :href="item.jobLink" v-if="item.jobLink">
                            <img :src="item.benefitMaterialDO.imgUrl" width="100%">
                        </a>
                        <img :src="item.benefitMaterialDO.imgUrl" width="100%" v-else>
                        <!--<p style="margin: 0; padding: 0; font-size: 1.1rem;">{{item.benefitMaterialDO.name}}</p>-->
                    </van-col>
                </van-row>
            </div>

            <div v-if="benefitMap.middle && benefitMap.middle.length > 0" style="margin-bottom: 1rem;">
                <van-swipe :autoplay="autoplay">
                    <van-swipe-item v-for="item in benefitMap.middle" :key="item.id">
                        <a :href="item.jobLink" v-if="item.jobLink">
                            <img :src="item.benefitMaterialDO.imgUrl" class="swipe_item"/>
                        </a>
                        <img :src="item.benefitMaterialDO.imgUrl" class="swipe_item" v-else/>
                    </van-swipe-item>
                </van-swipe>
            </div>

            <div v-if="benefitMap.big && benefitMap.big.length > 0">
                <van-row gutter="10">
                    <van-col v-for="item in benefitMap.big" span="8" style="margin-bottom: 1rem;">
                        <a :href="item.jobLink" v-if="item.jobLink">
                            <img :src="item.benefitMaterialDO.imgUrl" width="100%" class="big_item">
                        </a>
                        <img :src="item.benefitMaterialDO.imgUrl" width="100%" class="big_item" v-else>
                    </van-col>
                </van-row>
            </div>
        </div>
    </div>
</template>

<script>
    import benefitAPI from '@/api/benefit';
    import constantAPI from '@/api/constant';
    import wxShare from '@/utils/wxShareService';
    import pvuvAPI from '@/api/pvuv';

    export default {
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                },
                benefitMap: {},
                autoplay: 3000,
            }
        },
        methods: {
        },
        created() {
            document.title = "领福利";
            if (!this.query.traderId) {
                return;
            }

            benefitAPI.queryList(this.query).then((result) => {
                this.benefitMap = result.data;
            }).catch(() => {
            })
        },
        mounted() {
            let shareInfo = {
                "imgUrl": "http://jho2o.oss-cn-beijing.aliyuncs.com/test/2Ns9IUQR.png",
                "title": "领福利",
                "desc": "红包优惠券、特价话费流量、免费实物礼品，这是一个只有福利的页面！",
                "link": window.location.href,
            };
            constantAPI.weChatShareConfig(shareInfo.link).then((result) => {
                wxShare.setWxConfig(result.data);
                wxShare.setShare(shareInfo);
            });
            pvuvAPI.addPv("benefit/index", this.query.traderId).then((result) => {
            });
        }
    }

</script>

<style lang="scss" scoped>
    .background {
        /*background: url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxFzAd0.png') no-repeat;*/
        /*background-size: 100%;*/
        padding-top: 2rem;
        text-align: center;
    }

    .container {
        width: 90%;
        margin: 0 auto;
    }

    .column {
        /*background: rgba(255, 255, 255, 1);*/
        /*box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.05);*/
        padding: 1rem 1rem 0 1rem;
        /*border-radius: 1rem;*/
    }

    .swipe_item {
        height: 175px;
        width: 100%;
    }

    .big_item {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.05);
        border-radius: 1rem;
    }

</style>
